import axios from 'axios';

const version = 'v1';
const basePath = 'manifest';

export async function getListByPreparationId(preparationOrderId) {
  return axios.request({
    url: `/${version}/${basePath}/${preparationOrderId}`,
    method: 'get',
  });
}

export async function getAll({ agency_id, page = 1, itemsPerPage = 100 }) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
      ...(agency_id.length && {
        agency_id: {
          in: agency_id.join(','),
        },
      }),
      limit: itemsPerPage,
      skip: itemsPerPage * (page - 1),
    },
  });
}

export async function getManifestData(shipment_references) {
  return axios.request({
    url: `/${version}/${basePath}/`,
    method: 'post',
    data: shipment_references,
  });
}

/** @deprecated */
export async function createPreparationOrderManifest(reference) {
  return axios.request({
    url: `/${version}/${basePath}/preparation-order/${reference}`,
    method: 'post',
  });
}

export async function createManifest(agency_code) {
  return axios.request({
    url: `/${version}/${basePath}/create/${agency_code}`,
    method: 'post',
  });
}
